import { DEMO_IDS } from './mqttPacket'

export const seedFabricantes = () => ({
    count: 1,
    next: null,
    previous: null,
    results: [{ id: DEMO_IDS.fabricante, nome: 'Afira Demo' }],
})

export const seedModelos = () => ({
    count: 1,
    next: null,
    previous: null,
    results: [{ id: DEMO_IDS.modelo, modelo: 'Sensor MQTT Demo', fabricante: DEMO_IDS.fabricante }],
})

export const seedOperadoras = () => ({
    count: 1,
    next: null,
    previous: null,
    results: [{ id: DEMO_IDS.operadora, nome: 'Operadora Demo', possui_chip: true }],
})

export const seedTimezones = () => ({
    count: 2,
    next: null,
    previous: null,
    results: [
        { codigo: 'America/Sao_Paulo' },
        { codigo: 'UTC' },
    ],
})

export const seedTipoAcessos = () => ([
    {
        acesso_tipo__id: DEMO_IDS.tipoAcesso,
        acesso_tipo__descricao: 'Acesso Demo',
    },
])

export const seedMonitoradoTipos = () => [
    {
        id: DEMO_IDS.tipoMonitorado,
        nome: 'Ponto Demo',
        icone: 'las la-tint',
        cor: '#2f80ed',
    },
]

export const seedPermissoesCliente = () => ({
    count: 1,
    next: null,
    previous: null,
    results: {
        Base: [
            {
                nome: 'Geral',
                permissoes: [
                    { id: DEMO_IDS.permissaoBase, descricao: 'Visualizar Dashboard' },
                    {
                        id: DEMO_IDS.permissaoBase + 1,
                        descricao: 'Visualizar Lista de Monitorados',
                    },
                    { id: DEMO_IDS.permissaoBase + 2, descricao: 'Cadastrar Cliente' },
                    { id: DEMO_IDS.permissaoBase + 3, descricao: 'Editar Cliente' },
                    { id: DEMO_IDS.permissaoBase + 4, descricao: 'Cadastrar Monitorado' },
                    { id: DEMO_IDS.permissaoBase + 5, descricao: 'Editar Monitorado' },
                ],
            },
        ],
    },
})

export const seedModulosAcesso = () => ({
    total: [
        {
            acesso_tipo: DEMO_IDS.tipoAcesso,
            acesso_tipo__descricao: 'Acesso Demo',
            tcount: 100,
        },
    ],
    utilizados: [],
    count: 1,
    next: null,
    previous: null,
    results: [
        {
            id: 1,
            descricao: 'Base',
            acesso_tipo: { id: DEMO_IDS.tipoAcesso, descricao: 'Acesso Demo' },
        },
    ],
})

export const seedConfigCores = () => ({
    primaria: '#2f80ed',
    secundaria: '#56ccf2',
})

export const seedConfigSistema = () => ({
    nome: 'Hidroview Demo',
})
